import React from 'react';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import ServiceIntro from '../../components/ServiceIntro/ServiceIntro';
import ProductList from '../../components/ProductList/ProductList';
import productsData from '../../data/products.json';

const tradeContent = {
  title: "跨境贸易&进出口管理",
  subtitle: "专业的跨境贸易解决方案",
  description: [
    "在跨境贸易日益复杂的今天，我们的软件解决方案致力于帮助企业高效管理国际业务，轻松应对贸易合规、风险控制和物流协调的挑战。无论是精准把握全球市场动态，还是优化进出口流程，我们都通过智能化、自动化的平台支持企业在国际竞争中稳步前行，助力企业迈向全球成功。",
    "向下滑动，立即探索我们丰富的产品系列，找到最适合您的跨境贸易解决方案。",
  ],
  image: "/images/solutions/kuajing.png"
};

export const tradeProducts = {
  title: "软件解决方案",
  subtitle: "跨境贸易&进出口管理",
  products: productsData.products
};

const Trade = () => {
  return (
    <div className="trade-page flex flex-col min-h-screen">
      <Navbar />
      <ServiceIntro {...tradeContent} />
      <div style={{backgroundColor: '#f8f9fa'}}>
        <ProductList {...tradeProducts} />
      </div>
      <div className='mt-auto'  style={{backgroundColor: '#f8f9fa'}}>
        <div className='container'>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default Trade; 